import type { EventId, MyBet } from '@swf/generated/types/api/sports';
import { EventTypeId } from '@swf/sports/types/eventType';

const eventTypeIdIsValid = (eventTypeId: number): eventTypeId is EventTypeId =>
  Object.values(EventTypeId).includes(eventTypeId);

export const getEventTypesWithEventIds = (bets: MyBet[]) =>
  bets
    .map((bet) => bet.legs.map((leg) => leg.parts.map((part) => [part.sportId, part.eventId])))
    .flat(2)
    .reduce<Partial<Record<EventTypeId, EventId[]>>>((acc, curr) => {
      const [sportId, eventId] = curr;
      const eventTypeId = Number(sportId);
      const eventIdAsNumber = Number(eventId);

      if (!sportId || !eventId || !eventTypeIdIsValid(eventTypeId)) {
        return acc;
      }

      const eventIdList = acc[eventTypeId];
      const shouldAddEventToList = !eventIdList?.includes(eventIdAsNumber);

      if (shouldAddEventToList) {
        acc[eventTypeId] = eventIdList ? [...eventIdList, eventIdAsNumber] : [eventIdAsNumber];
      }

      return acc;
    }, {});
